import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

export function injectScripts(optimizely: UtilityContext['optimizely'], trackingAllowed: boolean): HTMLScriptElement[] {
	const { init, tracking, scriptUrl, onOptimizelyLoad } = optimizely.getScript(trackingAllowed);

	const initScript = document.createElement('script');
	initScript.textContent = init;

	const trackingScript = document.createElement('script');
	trackingScript.textContent = tracking;

	const externalScript = document.createElement('script');
	externalScript.src = scriptUrl;

	const onLoadScript = document.createElement('script');
	onLoadScript.textContent = onOptimizelyLoad;

	const scripts = [initScript, trackingScript, externalScript, onLoadScript];
	for (const script of scripts) {
		document.head.appendChild(script);
	}
	return scripts;
}
